import RedirectView from "views/RedirectView/RedirectView";

export default function RedirectPage() {
    return (
        <RedirectView />
    );
}
